export default "__VITE_ASSET__BID_WTU8__"